export interface ILocation {
  id: number;
  type: LocationType;
  city: ILocationCity;
  state: ILocationState;
  region: ILocationRegion;
  country: ILocationCountry;
}

export enum LocationType {
  COUNTRY = 'country',
  REGION = 'region',
  STATE = 'state',
  CITY = 'city',
}

export interface ILocationState {
  id: string;
  code: string;
  name: string;
  region: ILocationRegion;
}

export interface ILocationRegion {
  id: string;
  code: string;
  name: string;
  country: ILocationCountry;
}

export interface ILocationCountry {
  id: string;
  code: string;
  name: string;
}

export interface ILocationCity {
  id: string;
  name: string;
  state: ILocationState;
}
